module.exports = __webpack_public_path__ + "static/media/Jennifer Silver Headshot_1707764128257.7938a20e.jpeg";